export default __webpack_public_path__ + "static/media/campfire.d60ada75.svg";